import React, {useEffect} from "react";
import {useNavigate} from 'react-router-dom';

/**
 * 404 NotFound 발생 시 나오는 페이지
 */
function NotFound() {
    const navigate = useNavigate();

    useEffect(() => {
        // body 에 클래스를 추가하여 스타일 변경
        document.querySelector('#header').style.display = 'none';
        document.querySelector('#footer').style.display = 'none';

        // 컴포넌트 언마운트 시 클래스 제거
        return () => {
            document.querySelector('#header').style.display = 'block';
            document.querySelector('#footer').style.display = 'block';
        };
    }, []);

    return (
        <div className="w_set">
            <div className="error-area">
                <i className="error-404"></i>
                <strong>죄송합니다.<br/>현재 요청하신 페이지를 찾을 수 없습니다.</strong>
                <p>이용에 불편을 드려서 죄송합니다. 잠시 후에 다시 시도해주세요.</p>
                <div className="btn-wrap">
                    <button type="button" className="btn color2" onClick={() => navigate(-1)}>이전페이지</button>
                    <button type="button" className="btn" onClick={() => navigate('/')}>메인으로</button>
                </div>
            </div>
        </div>
    );
}

export default NotFound;
